import { BriefDisplayStatus } from '../types';
import { DmBriefStatus, DmBriefTier } from '../gql-operations/gql-generated';

const {
    Active,
    ClosedBuyerBlocked,
    ClosedBuyerRestricted,
    ClosedByBuyer,
    ClosedFailedModeration,
    ClosedStale,
    PendingModeration,
    ClosedOrganizationRemoved,
    Deleted,
} = DmBriefStatus;

const ACTIVE_STATUSES = [Active, PendingModeration];
const CLOSED_STATUSES = [ClosedStale, ClosedByBuyer, ClosedOrganizationRemoved, Deleted];
const REJECTED_STATUSES = [ClosedFailedModeration, ClosedBuyerRestricted, ClosedBuyerBlocked];

export const calculateBriefDisplayStatus = (
    tier: DmBriefTier,
    status: DmBriefStatus,
    hasPreviousInvites: boolean,
    hiredCount: number,
    offersCount: number
): BriefDisplayStatus => {
    const isInviteFlow = [DmBriefTier.ManualInvites].includes(tier);

    if (status === DmBriefStatus.Deleted) {
        return BriefDisplayStatus.DELETED;
    }

    if (ACTIVE_STATUSES.includes(status)) {
        if (!isInviteFlow) return BriefDisplayStatus.LIVE;

        if (hasPreviousInvites) {
            return BriefDisplayStatus.LIVE;
        }
        return BriefDisplayStatus.NO_INVITES_SENT;
    }

    if (CLOSED_STATUSES.includes(status)) {
        if (hiredCount) {
            return BriefDisplayStatus.DONE;
        }
        return offersCount ? BriefDisplayStatus.INACTIVE : BriefDisplayStatus.DELETED;
    }

    if (REJECTED_STATUSES.includes(status)) {
        return BriefDisplayStatus.REJECTED;
    }

    return BriefDisplayStatus.UNKNOWN;
};
